import React from "react";

export const ContentTable = () => {
  return (
    <>
      <div className="custom-table-row" key={"item" + 1}>
        <div className="custom-table-cell flex-basis-16 flex-basis-15-6-sm">
          <span className="mobile-column-name">Tên khách hàng</span>
          <div className="center-wrapper">
            <p className="text-left">Nguyễn Văn A</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm">
          <span className="mobile-column-name">Số CCCD</span>
          <div className="center-wrapper">
            <p className="text-left">0123456789</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-13 flex-basis-12-sm">
          <span className="mobile-column-name">Tên cửa hàng</span>
          <div className="center-wrapper">
            <p className="text-left">
              Cầm đồ 678
              <br />
              (ĐT: 0912.999.999)
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-17 flex-basis-20-6-sm">
          <span className="mobile-column-name">Địa chỉ</span>
          <div className="center-wrapper">
            <p className="text-left">Số 2 Lê Văn Thiêm, Đống Đa, HN</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Kiểu vay</span>
          <div className="center-wrapper">
            <p className="text-center">Tín chấp</p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-11 flex-basis-8-sm">
          <span className="mobile-column-name">Số tiền vay</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span className="red">5,000,000</span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-10 flex-basis-11-sm action-cell">
          <span className="mobile-column-name">Tình trạng</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span className="canh-bao-red">Nợ xấu</span>
            </p>
          </div>
        </div>

        <div className="custom-table-cell flex-basis-10 flex-basis-8-sm  action-cell">
          <span className="mobile-column-name">Trạng thái</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span className="canh-bao-red">Quá hạn</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
